// Simple phonetic Singlish -> Sinhala transliteration for a live preview.
// Good enough for typing help; the optional "AI polish" fixes tricky spelling.

const HAL = "\u0DCA"; // ්

// order matters: longest tokens first
const INDEP_VOWELS = [
  ["aae", "\u0D88"], ["aa", "\u0D86"], ["ae", "\u0D87"], ["ai", "\u0D93"], ["au", "\u0D96"],
  ["ii", "\u0D8A"], ["ee", "\u0D8A"], ["uu", "\u0D8C"], ["oo", "\u0D95"],
  ["A", "\u0D86"], ["a", "\u0D85"], ["i", "\u0D89"], ["u", "\u0D8B"],
  ["E", "\u0D92"], ["e", "\u0D91"], ["O", "\u0D95"], ["o", "\u0D94"],
];

const DEP_VOWELS = [
  ["aae", "\u0DD1"], ["aa", "\u0DCF"], ["ae", "\u0DD0"], ["ai", "\u0DDB"], ["au", "\u0DDE"],
  ["ii", "\u0DD3"], ["ee", "\u0DD3"], ["uu", "\u0DD6"], ["oo", "\u0DDD"],
  ["A", "\u0DCF"], ["a", ""], ["i", "\u0DD2"], ["u", "\u0DD4"],
  ["E", "\u0DDA"], ["e", "\u0DD9"], ["O", "\u0DDD"], ["o", "\u0DDC"],
];

const CONSONANTS = [
  ["chh", "\u0DA1"], ["Chh", "\u0DA1"], ["ch", "\u0DA0"], ["Ch", "\u0DA0"],
  ["thh", "\u0DAE"], ["Thh", "\u0DA8"], ["dhh", "\u0DB0"], ["Dhh", "\u0DAA"],
  ["kh", "\u0D9B"], ["gh", "\u0D9D"], ["ng", "\u0D82"], ["gn", "\u0DA4"], ["ny", "\u0DA4"],
  ["th", "\u0DAD"], ["Th", "\u0DA8"], ["dh", "\u0DB0"], ["Dh", "\u0DAA"],
  ["sh", "\u0DC1"], ["Sh", "\u0DC2"], ["ph", "\u0DB5"], ["bh", "\u0DB7"], ["jh", "\u0DA3"],
  ["k", "\u0D9A"], ["g", "\u0D9C"], ["c", "\u0D9A"], ["j", "\u0DA2"],
  ["T", "\u0DA7"], ["t", "\u0DA7"], ["D", "\u0DA9"], ["d", "\u0DAF"], ["N", "\u0DAB"], ["n", "\u0DB1"],
  ["p", "\u0DB4"], ["b", "\u0DB6"], ["m", "\u0DB8"], ["y", "\u0DBA"], ["r", "\u0DBB"],
  ["l", "\u0DBD"], ["L", "\u0DC5"], ["v", "\u0DC0"], ["w", "\u0DC0"],
  ["s", "\u0DC3"], ["h", "\u0DC4"], ["f", "\u0DC6"], ["z", "\u0DC3"], ["q", "\u0D9A"],
];

const matchAt = (str, i, list) => {
  for (const [k, v] of list) if (str.startsWith(k, i)) return [k, v];
  return null;
};

export function singlishToSinhala(input) {
  if (!input) return "";
  let out = "";
  let i = 0;
  const n = input.length;
  while (i < n) {
    const cons = matchAt(input, i, CONSONANTS);
    if (cons) {
      const [ck, cv] = cons;
      i += ck.length;
      if (cv === "\u0D82") { out += cv; continue; } // anusvara — no vowel/hal
      const vow = matchAt(input, i, DEP_VOWELS);
      if (vow) {
        const [vk, vv] = vow;
        i += vk.length;
        out += cv + vv;
      } else {
        out += cv + HAL;
      }
      continue;
    }
    const iv = matchAt(input, i, INDEP_VOWELS);
    if (iv) {
      const [vk, vv] = iv;
      i += vk.length;
      out += vv;
      continue;
    }
    out += input[i];
    i += 1;
  }
  return out;
}

// Tap-keyboard palette (direct-insert Sinhala characters)
export const KB = {
  vowels: ["\u0D85", "\u0D86", "\u0D87", "\u0D88", "\u0D89", "\u0D8A", "\u0D8B", "\u0D8C", "\u0D91", "\u0D92", "\u0D94", "\u0D95"],
  consonants: [
    "\u0D9A", "\u0D9B", "\u0D9C", "\u0D9D", "\u0DA0", "\u0DA1", "\u0DA2", "\u0DA3",
    "\u0DA7", "\u0DA8", "\u0DA9", "\u0DAA", "\u0DAB", "\u0DAD", "\u0DAE", "\u0DAF",
    "\u0DB0", "\u0DB1", "\u0DB4", "\u0DB5", "\u0DB6", "\u0DB7", "\u0DB8", "\u0DBA",
    "\u0DBB", "\u0DBD", "\u0DC0", "\u0DC3", "\u0DC1", "\u0DC2", "\u0DC4", "\u0DC5", "\u0DC6",
  ],
  signs: ["\u0DCF", "\u0DD0", "\u0DD2", "\u0DD3", "\u0DD4", "\u0DD6", "\u0DD9", "\u0DDA", "\u0DDC", "\u0DDD", "\u0DCA", "\u0D82"],
};
